import classNames from 'classnames';

import { ConditionView } from '@/shared/ui';

import { formatDate } from '@/helpers/dates';

import { Typography } from '../../Typography';
import { BaseCard } from '../model/BaseCard/BaseCard';
import { ContractCardProps } from '../model/types';

import { DonwloadContractButton } from './ActionButtons/DonwloadContractButton';
import { Row, RowRenderer } from './RowRenderer';

export const ContractCard: React.FC<ContractCardProps> = ({
  data: { contractNumber, createdAt, updatedAt, title, endDate },
  onDownloadContract,
  informerData,
  variant,
}) => {
  const rows: Row[] = [
    {
      label: 'Номер договору',
      value: contractNumber,
      dataTestId: 'contract-card-number',
    },
    {
      label: 'Дата створення',
      value: formatDate(createdAt),
      dataTestId: 'contract-card-created-date',
    },
    {
      label: 'Дата оновлення',
      value: formatDate(updatedAt),
      dataTestId: 'contract-card-updated-date',
    },
  ];

  const endContractRow: Row[] = [
    {
      label: 'Дата завершення',
      value: formatDate(endDate),
      dataTestId: 'contract-card-date',
    },
  ];

  return (
    <BaseCard
      data-testid="contract-card"
      className={classNames('service-row-card', `service-row-card--${variant}`)}
      header={<Typography variant="H4">{title}</Typography>}
      body={
        <>
          <div className="service-row-card__meta-wrapper">
            <RowRenderer rows={rows} />
          </div>
          <div className="service-row-card__meta-wrapper">
            <RowRenderer rows={endContractRow} />
          </div>
        </>
      }
      informer={informerData}
      actions={[
        <ConditionView key="download-contract" if={!!onDownloadContract}>
          <DonwloadContractButton
            onClick={(): void =>
              onDownloadContract && onDownloadContract({ contractNumber, createdAt, updatedAt, title, endDate })
            }
          />
        </ConditionView>,
      ]}
    />
  );
};
